// Helper para colores de la barra (gafete)
export const isHexColor = (v: string) =>
    /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test((v || "").trim())
  
    export const textColorForBg = (hex: string) => {
        const c = hex.replace("#", "")
        const r = parseInt(c.length === 3 ? c[0] + c[0] : c.slice(0, 2), 16)
        const g = parseInt(c.length === 3 ? c[1] + c[1] : c.slice(2, 4), 16)
        const b = parseInt(c.length === 3 ? c[2] + c[2] : c.slice(4, 6), 16)
        const L = (0.299 * r + 0.587 * g + 0.114 * b) / 255
        return L > 0.6 ? "#111111" : "#FFFFFF"
}

export const getColorName = (hex: string): string => {
    const colorsNames: Record<string, string> = {
        "#1F7B5C" : "VERDE OSCURO",
        "#501168" : "MORADO",
        "#CA7C34" : "MARRON",
        "#000066" : "AZUL MARINO",
        "#D54125" : "ROJO",
        "#33CC33" : "VERDE LIMA",
        "#FFCC00" : "AMARILLO",
        "#03193F" : "AZUL NOCHE",
        "#941012" : "VINO",
    }

    const upperHex = hex.toUpperCase()
    return colorsNames[upperHex] || ""
}